module.exports = __webpack_public_path__ + "img/smoothr_logo.def9972e.svg";